import React from "react"
import { Link } from "gatsby"

import indexStyles from "../Styles/index.module.css"
import Layout from "../components/layout"
import macbook from "../images/macbook.jpg"
import githubLogo from "../images/githublogo.png"
import linkedinLogo from "../images/linkedinlogo.png"

import SEO from "../components/seo"

const IndexPage = () => (
  <Layout>
    <SEO title="Home" />
    <div className={indexStyles.div}>
      <section className={indexStyles.section}>
        <h1>Hola, soy Guillermo</h1>
        <h3>Programador Web Full Stack</h3>
        <p>
          Enfocado en la creación de sitios web con gran desempeño.
          <br />
          Te invito a conocer más sobre mi haciendo click
          <Link to="/sobreMi"> acá.</Link>
        </p>
      </section>
      <img className={indexStyles.macbook} src={macbook} alt="macbook logo" />
      <div>
        <a
          href="https://www.linkedin.com/in/guillermo-romero-lopez-50328b195/"
          target="_blank"
          rel="noreferrer"
        >
          <img
            className={indexStyles.linkedinLogo}
            src={linkedinLogo}
            alt="linkedin logo"
          />
        </a>
        <a
          href="https://github.com/guillermoalfredorl"
          target="_blank"
          rel="noreferrer"
        >
          <img
            className={indexStyles.githubLogo}
            src={githubLogo}
            alt="giyhub logo"
          />
        </a>
      </div>
    </div>
  </Layout>
)

export default IndexPage
